import { NO_ACCESS_URL } from 'routes/constants';

export const getErrorRoute = (error) => {
  switch (error) {
    case 'unauthenticated':
      return NO_ACCESS_URL;
    default:
      return '/not-found';
  }
};
